import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/data-services/message.service';

@Component({
  selector: 'app-president-assistants',
  templateUrl: './president-assistants.component.html',
  styleUrls: ['./president-assistants.component.css']
})
export class PresidentAssistantsComponent implements OnInit {

  language = '';
  direction;
  defaultLanguage;

  constructor(private messageService: MessageService) {
    this.messageService.selectedLanguage.subscribe(res => {
      this.language = res.lang;
      this.direction = res.dir;
    });
   }

  ngOnInit(): void {
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
  }

}
